import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import LoginForm from './components/LoginForm';
import SecurityFeatures from './components/SecurityFeatures';
import BrandingSection from './components/BrandingSection';
import Icon from '../../components/AppIcon';
import { FullWidthSection, ContentWrapper } from '../../components/ui/Layout';

const AdminLogin = () => {
  const [language, setLanguage] = useState('en');
  const navigate = useNavigate();

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setLanguage(savedLanguage);

    const isAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';
    if (isAuthenticated) {
      navigate('/admin-dashboard');
    }
  }, [navigate]);

  const translations = {
    en: {
      footer: 'Africoffee Admin Portal',
      copyright: `© ${new Date()?.getFullYear()} WGIH. All rights reserved.`,
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      support: 'Support'
    },
    zh: {
      footer: 'Africoffee 管理门户',
      copyright: `© ${new Date()?.getFullYear()} WGIH. 保留所有权利。`,
      terms: '服务条款',
      privacy: '隐私政策',
      support: '支持'
    }
  };

  const t = translations?.[language];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-[60px] min-h-screen">
        <FullWidthSection padding="" py="py-12">
          <ContentWrapper maxWidth="6xl" padding="px-5">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
              <div className="hidden lg:block space-y-8">
                <BrandingSection language={language} />
                <SecurityFeatures language={language} />
              </div>

              <div className="flex flex-col items-center">
                <LoginForm language={language} />

                <div className="lg:hidden mt-8 w-full max-w-md">
                  <SecurityFeatures language={language} />
                </div>
              </div>
            </div>

            <div className="lg:hidden mt-8 max-w-md mx-auto">
              <BrandingSection language={language} />
            </div>
          </ContentWrapper>
        </FullWidthSection>

        <footer className="border-t border-border bg-card mt-16">
          <FullWidthSection padding="" py="py-8">
            <ContentWrapper padding="px-4">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name="Coffee" size={18} color="var(--color-primary)" />
                  </div>
                  <span className="text-sm font-medium text-foreground">
                    {t?.footer}
                  </span>
                </div>

                <div className="flex items-center gap-6 text-xs text-muted-foreground">
                  <button className="hover:text-foreground transition-smooth">
                    {t?.terms}
                  </button>
                  <button className="hover:text-foreground transition-smooth">
                    {t?.privacy}
                  </button>
                  <button className="hover:text-foreground transition-smooth">
                    {t?.support}
                  </button>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-border text-center">
                <p className="text-xs text-muted-foreground">
                  {t?.copyright}
                </p>
              </div>
            </ContentWrapper>
          </FullWidthSection>
        </footer>
      </main>
    </div>
  );
};

export default AdminLogin;